import { Map, List } from 'immutable';

import { BATCH_SELECT_PLAN, FETCH_RECURLY_PLANS, SELECT_PLAN } from './types';


const initialState = Map({
  elements: List(),
  isLoading: true,
  selected: Map(),
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_RECURLY_PLANS.REQUEST:
      return state.set('isLoading', true);
    case FETCH_RECURLY_PLANS.SUCCESS:
      return state.withMutations((newState) => {
        newState.set('elements', List(payload))
          .set('isLoading', false);
      });
    case FETCH_RECURLY_PLANS.FAILURE:
      return state.withMutations((newState) => {
        newState.set('isLoading', false)
          .set('elements', initialState.get('elements'));
      });
    case SELECT_PLAN:
      return state.setIn(['selected', payload.device_type], payload);
    case BATCH_SELECT_PLAN:
      return state.withMutations((mutable) => {
        Object
          .keys(payload)
          .forEach((deviceType) => {
            mutable.setIn(['selected', deviceType], payload[deviceType]);
          });
      });
    default:
      return state;
  }
};
